import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import "@/App.css";
import { PageHeader, Gallery } from "@/sections";

export default function DidgeridoosPage() {
  const [content, setContent] = useState(null);
  const [items, setItems] = useState([]);
  useEffect(() => {
    Promise.all([
      api.get("/site-content").then((r) => setContent(r.data)).catch(() => {}),
      api.get("/instruments?type=didgeridoo").then((r) => setItems(r.data)).catch(() => {}),
    ]);
  }, []);
  return (
    <div className="App">
      <Nav artisanName={content?.artisan_name || "Sacred Instruments"} />
      <PageHeader
        eyebrow="Wind · Voice · Didgeridoos"
        title="Didgeridoos that breathe the land"
        subtitle="Hand-carved didgeridoos — each one finished with a beeswax mouthpiece and tuned by hand for warm, grounded drone."
      />
      <Gallery items={items} emptyText="No didgeridoos yet — add them from the admin panel." />
      <Footer content={content || {}} />
    </div>
  );
}
